var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1895 13.5532C11.3595 13.5532 11.6585 13.6955 12.0673 14.1392C14.1846 16.4411 16.5649 18.2606 18.5665 19.3591C18.8535 19.5183 19.0138 19.6352 19.0138 19.7872C19.0138 19.9005 18.9981 20.0163 18.7473 20.0163C18.2976 20.0163 15.7739 19.5183 15.1071 19.2048C14.4366 18.8913 12.9945 17.7192 11.2739 14.7554C11.0797 14.4214 10.8735 14.132 10.8735 13.8631C10.8735 13.5954 11.1183 13.5532 11.1895 13.5532Z",
    fill: "#6C9BD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9042 5.08243C16.9042 5.08243 17.3226 5.90961 13.247 6.48236C13.6907 5.22351 13.9849 4.39513 13.9849 4.39513C14.2442 3.64272 13.6606 3.2002 13.2398 3.2002C12.8177 3.2002 12.5115 3.52335 12.3366 3.9297L11.1248 6.70302C9.53558 6.80912 8.35752 6.75366 7.82577 6.7006C7.08662 6.62705 6.89731 7.03702 6.89731 7.45422C6.89731 8.18252 8.18027 8.92167 9.00021 8.84088C9.5187 8.79265 9.81894 8.76974 10.2398 8.72754L5.73372 19.0274C5.5625 19.412 5.42383 20.0294 6.19674 20.0294C6.97086 20.0294 8.71202 19.324 9.00262 18.5041C9.12561 18.1592 10.0227 15.6162 11.0235 12.7826C11.5167 12.6837 13.3374 12.404 13.8439 12.404C14.3238 12.404 14.571 12.6198 14.571 12.8755C14.571 13.4687 13.1481 15.1701 10.3917 17.2681C10.0878 17.4985 10.3386 17.6805 10.4942 17.6805C10.9198 17.6805 12.8201 16.3783 13.7619 15.6669C14.7964 14.8867 16.6015 12.8538 16.6015 11.4261C16.6015 10.8618 16.3519 10.3457 15.2209 10.3457C14.1248 10.3457 12.1907 10.5893 11.7783 10.6423C12.046 9.88027 12.3113 9.13509 12.5573 8.43694C14.6903 8.14152 15.9624 7.9498 16.7112 7.79305C17.7422 7.5736 18.5706 6.98155 18.5706 6.37022C18.5706 5.06796 16.9042 5.08243 16.9042 5.08243Z",
    fill: "#6A2D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/한국투자증권-24.498ef5fc090a85e45e4947f232081c57.svg";
export { ForwardRef as ReactComponent };